export var headerNavbarConstants = [
    { title: "Home", route: "/dashboard" },
    {
        title: "Lead Dashboard",
        route: "/dashboard/lead-dashboard",
    },
    { title: "Revenue Dashboard", route: "/dashboard/revenue-dashboard" },
    { title: "Watch List", route: "#" },
    { title: "Transactions", dropDownList: [{ title: "", route: "#" }] },
    {
        title: "Reporting",
        dropDownList: [{ title: "MTF Report", route: "dashboard/mtf-report" }],
    },
    { title: "Service Request", route: "#" },
    { title: "Other Info", route: "#" },
];
export var deskPeriodMsg = "The cut off time to mark off desk is 10:30AM";
